import { Injectable, computed, inject, signal } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';

@Injectable({
  providedIn: 'root',
})
export class MediaMatcherService {
  private readonly media = inject(MediaMatcher);

  public readonly isMobileResolution = signal(true);
  public readonly isTabletResolution = signal(false);

  isMobile = computed(() => this.isMobileResolution() || this.isTabletResolution());

  constructor() {
    const tabletQuery = this.media.matchMedia('(max-width: 1024px)'); //LG TAILWIND BREAKPOINT
    const mobileQuery = this.media.matchMedia('(max-width: 768px)'); //MD TAILWIND BREAKPOINT
    const tabletQueryListener = () => this.isTabletResolution.set(tabletQuery.matches);
    const mobileQueryListener = () => this.isMobileResolution.set(mobileQuery.matches);
    this.isMobileResolution.set(mobileQuery.matches);
    this.isTabletResolution.set(tabletQuery.matches);
    mobileQuery.addEventListener('change', mobileQueryListener);
    tabletQuery.addEventListener('change', tabletQueryListener);
  }
}
